import { render } from "./CostsResults.vue?vue&type=template&id=20452e98"
import script from "./CostsResults.vue?vue&type=script&lang=js"
export * from "./CostsResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/results/CostsResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20452e98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20452e98', __exports__)) {
    api.reload('20452e98', __exports__)
  }
  
  module.hot.accept("./CostsResults.vue?vue&type=template&id=20452e98", () => {
    api.rerender('20452e98', render)
  })

}


export default __exports__